import React from 'react';
import BaseTemplate from './BaseTemplate';

const SeniorTemplate = ({ data }) => {
  return <BaseTemplate data={data} />;
};

export default SeniorTemplate;
